<template>
  <!-- Admin -->
  <div class="nav-bar-wrapper" v-if="isRuejaiPartnerAdmin">
    <div class="title mt-3">{{ 'ใบแจ้งหนี้' }}</div>
    <li class="divider "></li>
    <ul>
      <router-link
        :key="'invoice'"
        :to="{
          name: 'SupplierInvoiceDashboard',
          query: { status: 'in_progress' }
        }"
        tag="li"
        class="item pointer"
        active-class="active"
        @click.native="hideMobileNavBar"
      >
        <div>
          <img src="/static/icons/supplier-icon/navigation-created-icon.svg" />
          {{ "ใบแจ้งหนี้" }}
        </div>
      </router-link>
    </ul>
    <li class="divider"></li>
    <li class="mt-3"></li>
    <ul>
      <li
        class="item pointer"
        :class="!isDesktop ? 'last-item' : ''"
        @click="showLogoutMenu"
      >
        <img src="/static/icons/supplier-icon/navigation-logout-icon.svg" />
        {{ "ออกจากระบบ" }}
      </li>
    </ul>
  </div>

  <!-- Partner -->
  <div class="nav-bar-wrapper" v-else>
    <div class="title">{{ 'จัดการงาน' }}</div>
    <li class="divider"></li>
    <ul>
      <router-link
        :key="'newAppoint'"
        :to="{
          name: 'SupplierJobList',
          params: { navigationMenu: navigationMenu.NEW }
        }"
        tag="li"
        class="item pointer"
        active-class="active"
        @click.native="hideMobileNavBar"
      >
        <div>
          <img src="/static/icons/supplier-icon/navigation-created-icon.svg" />
          {{ "รอยืนยัน" }}
        </div>
      </router-link>
    </ul>
    <li class="divider"></li>
    <ul>
      <router-link
        :key="'inProgress'"
        :to="{
          name: 'SupplierJobList',
          params: { navigationMenu: navigationMenu.PENDING }
        }"
        tag="li"
        class="item pointer"
        active-class="active"
        @click.native="hideMobileNavBar"
      >
        <div>
          <img
            src="/static/icons/supplier-icon/navigation-confirmed-icon.svg"
          />
          {{ "ยืนยันแล้ว/รอดำเนินการ" }}
        </div>
      </router-link>
    </ul>
    <li class="divider"></li>
    <ul>
      <router-link
        :key="'finished'"
        :to="{
          name: 'SupplierJobList',
          params: { navigationMenu: navigationMenu.FINISHED }
        }"
        tag="li"
        class="item pointer"
        active-class="active"
        @click.native="hideMobileNavBar"
      >
        <div>
          <img
            src="/static/icons/supplier-icon/navigation-fulfilled-icon.svg"
          />
          {{ "ปิดงานแล้ว" }}
        </div>
      </router-link>
    </ul>
    <li class="divider"></li>
    <ul>
      <router-link
        :key="'report'"
        :to="{
          name: 'SupplierReportList',
          params: { navigationMenu: navigationMenu.REPORT }
        }"
        tag="li"
        class="item pointer"
        active-class="active"
        @click.native="hideMobileNavBar"
      >
        <div>
          <img src="/static/icons/supplier-icon/navigation-report-icon.svg" />
          {{ "รายงานการให้บริการ" }}
        </div>
      </router-link>
    </ul>
    <li class="divider"></li>
    <div class="title mt-3">{{ 'ใบแจ้งหนี้' }}</div>
    <li class="divider "></li>
    <ul>
      <router-link
        :key="'invoice'"
        :to="{
          name: 'SupplierInvoiceDashboard',
          query: { status: 'un_billed' }
        }"
        tag="li"
        class="item pointer"
        active-class="active"
        @click.native="hideMobileNavBar"
      >
        <div>
          <img src="/static/icons/supplier-icon/navigation-created-icon.svg" />
          {{ "ใบแจ้งหนี้" }}
        </div>
      </router-link>
    </ul>
    <li class="divider"></li>
    <li class="mt-3"></li>
    <ul>
      <li
        class="item pointer"
        :class="!isDesktop ? 'last-item' : ''"
        @click="showLogoutMenu"
      >
        <img src="/static/icons/supplier-icon/navigation-logout-icon.svg" />
        {{ "ออกจากระบบ" }}
      </li>
    </ul>
  </div>
</template>

<script>
import { mSize } from "../StaticVariable";
import { baanRueJaiClient } from "@/dependencies";
import { navigationMenu, permissionRole } from "../../lib/mapper";

export default {
  data() {
    return {
      windowWidth: window.innerWidth,
      roleId: parseInt(localStorage.getItem("supplierRoleId")),
    };
  },
  computed: {
    isDesktop() {
      return this.windowWidth >= mSize;
    },
    navigationMenu() {
      return navigationMenu;
    },
    isRuejaiPartnerAdmin() {
      return this.roleId === permissionRole.RJPADMIN;
    }
  },
  methods: {
    onResize() {
      this.windowWidth = window.innerWidth;
    },
    hideMobileNavBar() {
      this.$emit("hideMobileNavBar");
    },
    showLogoutMenu() {
      this.$emit("showLogoutMenu");
    },
    async logout(action) {
      if (action) {
        try {
          baanRueJaiClient.setAuthorizationToken();
        } catch (error) {
          console.debug(error);
        }

        localStorage.clear();
        this.$router.push({ name: "SupplierLogin" });
      } else {
        this.showLogoutDialog = false;
      }
    }
  },
  mounted() {
    this.$nextTick(() => {
      window.addEventListener("resize", this.onResize);
    });
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.onResize);
  }
};
</script>

<style lang="scss" scoped>
@import "../../css/otherWebVariables";
.nav-bar-wrapper {
  .title {
    padding: 16px;
    font-size: $font-16;
    font-weight: bold;
    color: $supplier-primary-color;
  }

  ul {
    padding: 0;
    margin: 0;
    list-style-type: none;

    li {
      padding: 16px;
    }

    > .item {
      color: $black;
      font-size: $font-16;
      border-left: 4px solid transparent;
      padding-left: 16px;

      &:hover {
        background-color: #f7f7f7;
        text-decoration: none;
        color: $black;
      }

      &.active,
      &:focus {
        background-color: #f7f7f7;
        text-decoration: none;
        font-weight: bold;
      }
      &.active {
        border-left: 4px solid $supplier-primary-color;
      }

      img {
        margin-right: 16px;
      }
    }
  }

  > .divider {
    margin-inline: 24px;
    margin-block: 2px;
    border-bottom: 1px solid $color-light-gray-1;
  }
}

@media (max-width: ($m-size - 1)) {
  .nav-bar-wrapper {
    ul {
      li {
        padding: 12px;
      }

      > .item {
        padding-left: 12px;

        img {
          width: 20px;
          height: 20px;
          margin-right: 12px;
        }
      }
    }

    > .divider {
      margin-inline: 16px;
    }
  }

  .last-item {
    border-bottom-left-radius: 8px;
    border-bottom-right-radius: 8px;
  }
}

@media (min-width: $m-size) and (max-width: ($ml-size - 1)) {
  .nav-bar-wrapper {
    ul {
      li {
        padding: 12px 4px;
      }

      > .item {
        font-size: $font-14;
        padding-left: 4px;

        img {
          width: 20px;
          height: 20px;
          margin-right: 6px;
        }
      }
    }

    > .divider {
      margin-inline: 12px;
    }
  }
}

@media (min-width: $ml-size) and (max-width: ($l-size - 1)) {
  .nav-bar-wrapper {
    ul {
      li {
        padding: 16px 8px;
      }

      > .item {
        font-size: $font-14;
        padding-left: 8px;

        img {
          width: 22px;
          height: 22px;
          margin-right: 12px;
        }
      }
    }

    > .divider {
      margin-inline: 12px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/other-web/supplier/components/SideNavigationItems.vue